<template>
  <modal
    name="configure-price-reduction-modal"
    class="configure-price-reduction-modal"
    @before-open="handleBeforeOpen"
    transition="fade"
    :adaptive="true"
    :scrollable="true"
    :reset="true"
    width="60%"
    height="auto"
    style="z-index: 4100;"
  >
    <div id="modal-header">
      <div class="w-100 d-flex">
        <p>
          Կազմակերպել գնիջեցում
        </p>
      </div>
      <button
        type="button"
        class="close position-absolute"
        style="right: 1.25rem; top: 30%"
        @click="$modal.hide('configure-price-reduction-modal')"
        aria-label="Close"
      >
        <span aria-hidden="true" class="text-white">&times;</span>
      </button>
    </div>
    <div id="modal-body" class="p-4">
      <form @submit.prevent="save">
        <div class="row">
          <div class="form-group col-md-6">
            <div class="mb-3 pl-1">
              <label for="price-reduction-date">Գնիջեցման բացման ամսաթիվ</label>
              <date-pick
                v-model="startDate"
                class="date-picker tender-date-picker"
                setTimeCaption="Ժամը՝"
                :format="'YYYY-MM-DD'"
                :pickTime="false"
                :weekdays="['Երկ', 'Երք', 'Չոր', 'Հին', 'Ուր', 'Շբթ', 'Կիր']"
                :months="['Հունվար', 'Փետրվար', 'Մարտ', 'Ապրիլ', 'Մայիս', 'Հունիս', 'Հուլիս', 'Օգոստոս', 'Սեպտեմբեր', 'Հոկտեմբեր', 'Նոյեմբեր', 'Դեկտեմբեր']"
                :inputAttributes="{readonly: true, placeholder: 'Գնիջեցման սկսման օր'}"
                id="price-reduction-date"
                :isDateDisabled="isPastDate"
              />
            </div>
          </div>
          <div class="form-group col-md-6">
            <div class="mb-3 pl-1">
              <label for="price-reduction-time">Գնիջեցման բացման ժամ</label>
              <select v-model="startTime" class="form-control" id="price-reduction-time">
                <option
                  v-for="time in timeOptions()"
                  :key="time"
                  :value="time"
                >
                  {{ time }}
                </option>
              </select>
            </div>
          </div>
        </div>

        <div class="form-group col-md-12 p-0 mt-3" v-if="participantsList.length">
          <p class="tender-label mb-2 font-weight-bold">Ծանուցվող մասնակիցներ</p>
          <div class="border rounded p-3 bg-light" style="max-height: 250px; overflow-y: auto;">
            <div class="d-flex justify-content-between align-items-center mb-2 pb-2 border-bottom">
              <div class="form-check m-0">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="select-all-reduction-participants"
                  :checked="isAllParticipantsSelected"
                  @change="toggleSelectAllParticipants"
                >
                <label class="form-check-label font-weight-bold cursor-pointer" for="select-all-reduction-participants">
                  Ընտրել բոլորը
                </label>
              </div>
              <span class="text-muted small">
                Ընտրված է {{ selectedUserIds.length }} / {{ participantsList.length }}
              </span>
            </div>
            <div
              v-for="(participant, index) in participantsList"
              :key="getParticipantUserId(participant) || index"
              class="form-check py-1"
            >
              <input
                class="form-check-input"
                type="checkbox"
                :id="`reduction-participant-${getParticipantUserId(participant)}`"
                :value="getParticipantUserId(participant)"
                v-model="selectedUserIds"
              >
              <label
                class="form-check-label d-flex justify-content-between align-items-center cursor-pointer"
                :for="`reduction-participant-${getParticipantUserId(participant)}`"
              >
                <span>
                  {{ getParticipantName(participant) }}
                  <span v-if="getParticipantTin(participant)" class="text-muted small ml-1">
                    (ՀՎՀՀ՝ {{ getParticipantTin(participant) }})
                  </span>
                </span>
                <span
                  v-if="isSatisfactory(participant)"
                  class="badge badge-success ml-2"
                  style="font-size: 11px;"
                >
                  Բավարար
                </span>
                <span
                  v-else
                  class="badge badge-warning ml-2"
                  style="font-size: 11px;"
                >
                  Անբավարար
                </span>
              </label>
            </div>
          </div>
        </div>
      </form>
    </div>
    <div id="modal-footer" class="p-3">
      <button type="button" @click="$modal.hide('configure-price-reduction-modal')" class="btn btn-light mr-3">
        Չեղարկել
      </button>
      <button :disabled="isLoading || !selectedUserIds.length" @click="save" class="btn btn-primary br-8">
        <span v-if="isLoading" class="mr-2 spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        <span>Պահպանել</span>
      </button>
    </div>
  </modal>
</template>

<script>
import DatePick from 'vue-date-pick';
import 'vue-date-pick/dist/vueDatePick.css';

export default {
  name: 'ConfigurePriceReductionModal',
  components: { DatePick },
  data() {
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);

    return {
      isLoading: false,
      startDate: tomorrow.toISOString().split('T')[0],
      startTime: '09:00',
      participantsList: [],
      selectedUserIds: [],
    };
  },
  computed: {
    currentOrganized() {
      return this.$store.getters['organizeItender/currentOrganized'];
    },
    isAllParticipantsSelected() {
      if (!this.participantsList.length) {
        return false;
      }
      const allIds = this.participantsList
        .map(p => this.getParticipantUserId(p))
        .filter(id => id !== null && id !== undefined);

      if (!allIds.length) {
        return false;
      }

      const selected = this.selectedUserIds || [];
      return allIds.every(id => selected.includes(id));
    },
  },
  methods: {
    handleBeforeOpen({ params }) {
      const tomorrow = new Date();
      tomorrow.setDate(tomorrow.getDate() + 1);
      this.startDate = tomorrow.toISOString().split('T')[0];
      this.startTime = '09:00';

      const participants = (params && params.participants && params.participants.length)
        ? params.participants
        : (this.currentOrganized?.participants || []);

      this.participantsList = JSON.parse(JSON.stringify(participants));
      this.selectedUserIds = this.getDefaultPublishToUserIds(this.participantsList);
    },
    isPastDate(date) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      date.setHours(0, 0, 0, 0);
      return date < today;
    },
    timeOptions() {
      const times = [];
      for (let hour = 0; hour <= 24; hour++) {
        for (let min = 0; min < 60; min += 30) {
          if (hour === 24 && min > 0) {
            // avoid 24:30
            break;
          }
          const h = String(hour).padStart(2, '0');
          const m = String(min).padStart(2, '0');
          times.push(`${h}:${m}`);
        }
      }
      return times;
    },
    getParticipantUserId(participant) {
      if (!participant) return null;
      const id = participant.user_datas?.id ?? participant.id;
      return isNaN(Number(id)) ? id : Number(id);
    },
    isSatisfactory(participant) {
      if (!participant) return false;
      if (Array.isArray(participant.lots) && participant.lots.length > 0) {
        const lotsWithEval = participant.lots.filter(lot => lot.is_satisfactory !== undefined && lot.is_satisfactory !== null);
        if (lotsWithEval.length > 0) {
          const anySatisfactory = lotsWithEval.some(lot => +lot.is_satisfactory === 1);
          const allUnsatisfactory = lotsWithEval.every(lot => +lot.is_satisfactory === 0);
          if (allUnsatisfactory) return false;
          if (anySatisfactory) return true;
        }
      }
      return Boolean(participant.pr_is_satisfactory);
    },
    getParticipantName(participant) {
      return typeof participant?.name === 'object'
        ? (participant.name.hy || participant.name.ru || '')
        : (participant?.name || '');
    },
    getParticipantTin(participant) {
      return participant?.tin || '';
    },
    toggleSelectAllParticipants(event) {
      if (event.target.checked) {
        const allIds = this.participantsList
          .map(p => this.getParticipantUserId(p))
          .filter(id => id !== null && id !== undefined);
        this.selectedUserIds = Array.from(new Set(allIds));
      } else {
        this.selectedUserIds = [];
      }
    },
    getDefaultPublishToUserIds(participants) {
      if (!participants || !participants.length) return [];
      return participants
        .filter(p => this.isSatisfactory(p))
        .map(p => this.getParticipantUserId(p))
        .filter(id => id !== null && id !== undefined);
    },
    async save() {
      try {
        this.isLoading = true;
        const organizeId = this.currentOrganized?.id || this.$route.params.id;
        const payload = {
          organize_id: organizeId,
          start_at: `${this.startDate} ${this.startTime}`,
          publish_to_user_ids: this.selectedUserIds,
        };

        await this.$client.post(`organize/itender/price-reduction/${organizeId}`, payload);

        this.$notify({
          group: 'foo',
          type: 'success',
          text: 'Գնիջեցումը հաջողությամբ կազմակերպվել է'
        });

        if (this.currentOrganized?.id) {
          await this.$store.dispatch('organizeItender/getCurrent', this.currentOrganized.id);
        }

        this.$modal.hide('configure-price-reduction-modal');
        this.$modal.hide('winner-evalution-modal');
      } catch (e) {
        console.error(e);
        this.$notify({
          group: 'foo',
          type: 'error',
          title: 'Ինչ-որ բան այն չէ',
          text: 'Կրկին փորձեք!'
        });
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}
</style>
